import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';

import { LocalStorageService } from '@services/local-storage.service';

@Component({
  selector: 'app-greeting',
  standalone: true,
  imports: [],
  templateUrl: './greeting.component.html',
  styleUrls: ['./greeting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GreetingComponent implements OnInit {
  private localStorageService = inject(LocalStorageService);
  user: { firstname: string };

  get greeting() {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return 'Good morning';
    }
    if (currentHour >= 12 && currentHour < 18) {
      return 'Good afternoon';
    }
    if (currentHour >= 18 || currentHour < 5) {
      return 'Good evening';
    }

    return '';
  }

  ngOnInit(): void {
    this.user = this.localStorageService.getItem('user_info') ?? null;
  }
}
